import { CourseStudentDocument, courseStudentsApi } from "api/courseStudentsApi";
import { COURSE_DOCUMENT_FILE_STATUS } from "consts";
import { QUERIES_KEYS } from "queries";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

export const useCourseStudentsDocuments = (courseId?: string | number) => {
  const [refetchInterval, setRefetchInterval] = useState<number | undefined>(undefined);

  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_STUDENTS_DOCUMENTS(courseId!),
    queryFn: () => courseStudentsApi.fetechDocuments(Number(courseId)),
    enabled: !!courseId,
    refetchInterval,
  });

  useEffect(() => {
    if (
      data?.data?.some((document: CourseStudentDocument) =>
        document.documents.some((x) => x.status == COURSE_DOCUMENT_FILE_STATUS.Generating),
      )
    ) {
      setRefetchInterval(1000);
    } else {
      setRefetchInterval(undefined);
    }
  }, [data]);

  return { isLoading, documents: data?.data ?? [], refetch };
};
